function t() {
  return {
    textMargin: "0 4px",
    dividerMargin: "16px 0 16px 0",
    positionLeftWidth: "16px",
    positionRightWidth: "16px",
    fontSize: "13px",
    lineHeight: "18px",
    textColor: "var(--gray-600)",
    color: "var(--gray-200)"
  };
}
export {
  t as createDefaultTheme
};
